/**
 * Analytics (PostHog) somente após consentimento LGPD.
 * Chave localStorage: ufokko_analytics_consent = 'granted' | 'denied'
 */
export const ANALYTICS_CONSENT_KEY = 'ufokko_analytics_consent';

const POSTHOG_KEY = 'phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE';
const POSTHOG_HOST = 'https://us.i.posthog.com';

export function getAnalyticsConsent() {
  try {
    return localStorage.getItem(ANALYTICS_CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setAnalyticsConsent(value) {
  try {
    localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  } catch {
    /* ignore quota / private mode */
  }
}

function loadPosthogSnippet() {
  if (typeof window === 'undefined') return;
  if (window.__ufokkoPosthogLoaded) return;
  window.__ufokkoPosthogLoaded = true;

  !(function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split('.');
          2 == o.length && ((t = t[o[0]]), (e = o[1]));
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        }
        ((p = t.createElement('script')).type = 'text/javascript'),
          (p.crossOrigin = 'anonymous'),
          (p.async = !0),
          (p.src =
            s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') +
            '/static/array.js'),
          (r = t.getElementsByTagName('script')[0]).parentNode.insertBefore(p, r);
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = 'posthog'),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = 'posthog';
              return (
                'posthog' !== a && (e += '.' + a),
                t || (e += ' (stub)'),
                e
              );
            },
            u.people.toString = function () {
              return u.toString(1) + '.people (stub)';
            },
            (o =
              'init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric'.split(
                ' '
              )),
            (n = 0);
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);

  window.posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
  });
}

/** Inicia PostHog se o usuário já tiver concedido consentimento. */
export function initAnalyticsIfConsented() {
  if (getAnalyticsConsent() === 'granted') {
    loadPosthogSnippet();
  }
}

export function acceptAnalytics() {
  setAnalyticsConsent('granted');
  loadPosthogSnippet();
}

export function denyAnalytics() {
  setAnalyticsConsent('denied');
  if (window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
    window.posthog.opt_out_capturing();
  }
}
